import { QueryFunction, useQuery } from 'react-query';
import {
    getNeedsValidationTime,
    NeedsValidationTimeData,
    NeedsValidationTimeParams
} from '../../services/apiSLTP/reporting/reporting';


type UseNeedsValidationTimeQueryOptions = {
    params: NeedsValidationTimeParams;
};

const getNeedsValidationTimeQuery: QueryFunction<NeedsValidationTimeData[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseNeedsValidationTimeQueryOptions];
    const { params } = options;

    const response = await getNeedsValidationTime(params);
    return response.data;
};

export const useReportingNeedsValidationTimeQuery = (options: UseNeedsValidationTimeQueryOptions) => {
    return useQuery(['reportingNeedsValidationTime', options], getNeedsValidationTimeQuery);
};
